import type { ReactElement } from 'react'
import React from 'react'

import { ProductDiscontinuedBanner } from '@modules/Dashboard/modules/MigrateOffer/modules/ProductDiscontinuedBanner/ProductDiscontinuedBanner'
import { insertIf } from '@utils/insertIf'
import { routing } from '@utils/routing'

import type { Product } from '../../../../../../__models__'
import type { useOffer } from '../../../hooks/useOffer'
import { CombinedAlert } from '../../components/CombinedAlert/CombinedAlert'

export type UseProductBanners = {
  productBanners: ReactElement[]
}

export type UseProductBannersProps = {
  offer: ReturnType<typeof useOffer>['offer']
  product: Product | undefined
}

export const useProductBanners = ({
  offer,
  product,
}: UseProductBannersProps): UseProductBanners => {
  if (!product || !offer) {
    return { productBanners: [] }
  }

  return {
    productBanners: [
      ...insertIf(
        product?.status === 'DISCONTINUED',
        <ProductDiscontinuedBanner offerId={offer.id ?? ''} product={product} />,
      ),
      ...insertIf(
        !!offer.parentOffer,
        <CombinedAlert
          combinedLink={routing.products.combined.combinedId.self.replace(
            ':combinedId',
            offer.parentOffer?.id ?? '',
          )}
          combinedName={offer.parentOffer?.name ?? ''}
        />,
      ),
    ],
  }
}
